import { render } from "./WebViewProLexis.vue?vue&type=template&id=17854ad2"
import script from "./WebViewProLexis.vue?vue&type=script&lang=js"
export * from "./WebViewProLexis.vue?vue&type=script&lang=js"

import "./WebViewProLexis.vue?vue&type=style&index=0&id=17854ad2&lang=css"

import exportComponent from "D:\\dev\\DiagDev-clean\\Projets autres\\AdminWSInterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__